import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetCustomerInvoiceByIdApi,
  GetCustomerInvoicesByIdAPI,
} from "../../ApiRequests";

export const fetchCustomerInvoice = createAsyncThunk(
  "fetch/CustomerInvoice",
  async (arg) => {
    try {
      let response;
      if (typeof arg === "string" && arg) {
        response = await GetCustomerInvoiceByIdApi(arg);
      } else {
        const params = typeof arg === "object" && arg ? arg : undefined;
        response = await GetCustomerInvoicesByIdAPI(params);
      }
      return response?.data?.data.payload;
    } catch (error) {
      console.log(error);
    }
    return [];
  }
);

const CustomerInvoiceSlice = createSlice({
  name: "CustomerInvoice",
  initialState: {
    loading: false,
    data: [],
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCustomerInvoice.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchCustomerInvoice.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.isError = false;
    });
    builder.addCase(fetchCustomerInvoice.rejected, (state) => {
      state.loading = false;
      state.isError = true;
    });
  },
});

export default CustomerInvoiceSlice.reducer;
